import { Component, OnInit, inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import {
  GetEnumValuesDto,
  GetTextParserByIdDto,
  TextParsersWithPaginationDto,
} from 'src/app/core/api/models';
import { TextParsersService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { AppDomService } from 'src/app/core/services/dom.service';
import { BaseIndexPageComponent } from 'src/app/pages/shared/base/components/base-index-page.component';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { MenuBtnComponent } from 'src/app/shared/global/menu-btn/menu-btn.component';
import { TextParserFormComponent } from './text-parser-form/text-parser-form.component';
import { TextParserInboxesModalComponent } from './text-parser-inboxes/text-parser-inboxes-modal/text-parser-inboxes-modal.component';
import { TextParserInboxesComponent } from './text-parser-inboxes/text-parser-inboxes.component';

@Component({
  selector: 'app-text-parser',
  templateUrl: './text-parser.component.html',
  styleUrls: ['./text-parser.component.scss'],
  imports: [
    MatInputModule,
    MenuBtnComponent,
    BaseIndexModule,
    TextParserInboxesComponent,
    TextParserFormComponent,
  ],
})

export class TextParserComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region properties
  pageName = PageNames.textParsers;

  /* Binding service endpoints */
  protected currentService = inject(TextParsersService);
  createGetApiMethodName: string =
    this.currentService.textParsersCreateGet.name;
  auditApiMethodName: string =
    this.currentService.textParsersGetTextParserAudits.name;
  deleteApiMethodName: string = this.currentService.textParsersDelete.name;
  paginationApiMethodName: string =
    this.currentService.textParsersGetTextParsersWithPagination.name;

  modelWithPagination$: Observable<TextParsersWithPaginationDto>;
  items$: Observable<Array<TextParsersWithPaginationDto>>;
  formPageConfig: FormPageConfig<GetTextParserByIdDto> = {};
  isVisibleTextParserInboxes: boolean = false;
  textParserFormula: any[] = [];
  textParserId: any;
  targetFormulaId: any;

  TextParserIfConditionTypesEnumValues: GetEnumValuesDto[] = [];
  TextParserThenConditionTypeEnumValues: GetEnumValuesDto[] = [];
  SmsSentPeriodTypeEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('TextParserIfConditionType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (values) => (this.TextParserIfConditionTypesEnumValues = values)
      );

    this.getEnumValuesApi('TextParserThenConditionType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (values) => (this.TextParserThenConditionTypeEnumValues = values)
      );

    this.getEnumValuesApi('SmsSentPeriodType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsSentPeriodTypeEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.title, name: 'title', hasSearch: true },
      {
        title: this.localizer.active,
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}isChildrenChange`,
        name: 'isChildrenChange',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: this.localizer.startDate,
        name: 'startDateTime',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: this.localizer.endDate,
        name: 'endDateTime',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //get by id
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .textParsersUpdateGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        try {
          this.formPageConfig.editData = res.data;
          this.pageConfig.isVisibleForm = true;
        } catch (error) {
          this.loggerService.logError(this.tagName, error, EventTypes.services);
        }
      });
  }

  getPollParserFormulaApi(parserId) {
    this.currentService
      .textParsersGetTextParserFormulaById({ id: parserId })
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        this.textParserFormula = res.data;
        if (res.data?.length > 0) this.onTextParserInboxes(parserId, res.data);
        else this.isVisibleTextParserInboxes = true;
      });
  }
  //#endregion

  getPollParserFormula(parserId) {
    this.unSubs();
    this.pageConfig.loading = true;
    this.getPollParserFormulaApi(parserId);
  }

  //inbox component
  onTextParserInboxes(parserId, textParserFormula) {
    const modalResult = this.dialogService.openModal({
      component: TextParserInboxesModalComponent,
      data: {
        textParserId: parserId,
        textParserFormula: textParserFormula,
        textParserIfConditionTypesEnumValues:
          this.TextParserIfConditionTypesEnumValues,
        textParserThenConditionTypeEnumValues:
          this.TextParserThenConditionTypeEnumValues,
        smsSentPeriodTypeEnumValues: this.SmsSentPeriodTypeEnumValues,
      },
    });

    const sub = modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((res) => {
        if (res) {
          this.textParserId = res?.parserId;
          this.targetFormulaId = res?.targetFormulaId;
          this.isVisibleTextParserInboxes = true;
        }
      });
  }
}
